
import {
  defineComponent
} from "vue";
import Menu from "@/components/menu.vue"; // @ is an alias to /src
import {
  mapState
} from "vuex";
import api from "@/api";

// import { copyText } from 'vue3-clipboard'
const pepa  = require('vue3-clipboard')

function makeid(length: any) {
  var result = '';
  var characters = 'abcdef0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export default defineComponent({
  name: "Avatar",
  components: {
    Menu
  },
  mounted() {

    let k = localStorage.getItem('location_thing')
    if (k == 'Russia'){
      this.$data.g_link = 'https://portret.ai/ru#myprice'
    }
    api.list_prompts().then((data: any) => {
      this.$store.commit('set_prompts_list', data.data)
    })
    api.avatars(1).then((data: any) => {
      console.log('avatars');
      console.log(data);
      this.$store.commit('set_avatars', data.data)
    })

  },
  data() {
    return {
      g_link : 'https://buy.stripe.com/fZe3dT5hkdVs8ZqcN4',
      loading: false,
      creating : false,
      text : ''
    }
  },
  methods: {
    ping(item:any){
      let str = item.prompt.replace('alexanderkozhevin', 'coolperson')
      this.$notify('Prompts copied');

      pepa.copyText(str, undefined, (error:any, event:any) => {

      })


      // console.log(str);


    },
    reload(){
      this.$store.commit('set_page', 1)
      this.$data.loading = true
      api.avatars(1).then((data: any) => {
        this.$store.commit('set_avatars', data.data)
        this.$data.loading = false

      })
    },
    training() {
      if (this.status != 'ready'){
        alert('training not finished')
        return;
      }
      if (this.$data.text.indexOf('coolperson') == -1){
        alert('no coolperson keyword found :/')
        return;
      }
      this.$data.creating = true
      api.new_prompt(this.$data.text).then(()=>{
        setTimeout(() => {
          api.list_prompts().then((data: any) => {
            this.$store.commit('set_prompts_list', data.data)
          })
          this.$data.creating = false
          this.$data.text = ''
        }, 2000);
      })

    },
    paginate(shift: any) {
      let val = this.page_index + shift
      if (val < 1) {
        val = 1
      }
      this.$store.commit('set_page', val)
      this.$data.loading = true
      api.avatars(val).then((data: any) => {
        this.$store.commit('set_avatars', data.data)
        this.$data.loading = false

      })

    }
  },
  computed: {
    ...mapState({
      prompts_list: (state: any) => state.prompts_list,
      status: (state: any) => state.status,
      paid: (state: any) => state.paid,
      photos: (state: any) => state.photos,
      avatars: (state: any) => state.avatars,
      page_index: (state: any) => state.page_index
    })
  },
});
